import {post} from "../api"
import * as url from "../url"

const getLoggedInUser = () => {
  const user = localStorage.getItem("authUser")
  if (user) return JSON.parse(user)
  return null
}

const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

const apiPostJwtLogin = data => {
  return post(url.API_LOGIN, data.history, data.values)
}

export {
  getLoggedInUser,
  isUserAuthenticated,
  apiPostJwtLogin,
}
